import axios from 'axios';

export default function createInstance() {
  return axios.create({
    headers: {
      'Content-Type': 'multipart/form-data; charset=utf-8',
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
    },
  });
}
